module.exports = __webpack_public_path__ + "img/iconHotel.d7ac67d5.png";